export const FETCH_APPSETTINGS = 'FETCH_APPSETTINGS';
export const SET_FIREBASE_APP = 'SET_FIREBASE_APP';
